'use strict';

import React, { Component } from 'react'

import Layout from '@Layout/FrontOffice'

import getFormStatus from '@/Form/Functions/getFormStatus'

import Loader from '@Pure/Loader'

import request from '@function/ajax/request'

const { app } = window;

export default class CancelLoginPage extends Component
{
	state = { };

	UNSAFE_componentWillMount ()
	{
		const component = this, props = this.props, state = this.state;

		app.resetFunctions();
	}

	componentDidMount ()
	{
		const component = this, props = this.props, state = this.state;

		const controller = new AbortController();

		component.setState({ loading: true });

		(async function ()
		{
			try
			{
				var response = await request('/cancel-session')
				.config({ controller, keyword: 'action' })
				.post(
				{
					token: document.location.pathname
					.slice(document.location.pathname.lastIndexOf('/') + 1)
				});
			}
			catch (update)
			{
				if (controller?.signal?.aborted) return;

				component.setState({ loading: false });

				return component.setState(update);
			}

			component.setState({ loading: false, info: response.info });
		})();
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		const loader = state.loading === true ?
		(
			<Loader className="c-loader" bemit={ ['primary', 'bg-white'] } />
		)
		: undefined;

		var output =
		(
			<Layout page_title="Annulation de connexion">

				<div className="u-table u-full-width"
					style={ { 'minHeight': '100%' } }>

					<div className="u-table-row">

						<div className="u-table-cell u-vertical-align-middle">

							<div className="c-paper u-positioned"
								style={ { height: loader ? 260 : 'auto',
									width: 600, maxWidth: '100%' } }>

								{ loader }

								{ getFormStatus(state) }

							</div>

						</div>

					</div>

				</div>

			</Layout>
		);

		return output;
	}
}
